/* eslint-disable @trello/export-matches-filename */
import type { SaveMessages, SaveProfileError } from './SaveProfileErrors';
import {
  saveProfileErrorMapping,
  SaveProfileErrors,
} from './SaveProfileErrors';

type MemberHomeProfileState = {
  saveMessage: SaveMessages;
  saveErrors?: SaveProfileError[];
};

export const initialMemberHomeProfileState: MemberHomeProfileState = {
  saveMessage: 'save',
};

const SAVE_PROFILE_START = Symbol('ui/SAVE_PROFILE_START');
const SAVE_PROFILE_COMPLETE = Symbol('ui/SAVE_PROFILE_COMPLETE');
const SAVE_PROFILE_RESET = Symbol('ui/SAVE_PROFILE_RESET');
const SAVE_PROFILE_ERROR = Symbol('ui/SAVE_PROFILE_ERROR');

export const saveProfileResetCreator = () => {
  return { type: SAVE_PROFILE_RESET };
};
export const saveProfileErrorCreator = (errors: string) => {
  return { type: SAVE_PROFILE_ERROR, payload: errors };
};

export const saveProfileCompleteCreator = () => {
  return { type: SAVE_PROFILE_COMPLETE };
};

export const saveProfileStartCreator = () => {
  return { type: SAVE_PROFILE_START };
};

export const memberHomeProfileReducer = (
  state: MemberHomeProfileState,
  action: {
    type: symbol[] | symbol;
    payload?: SaveProfileError[] | string;
  },
): MemberHomeProfileState => {
  const payload = action.payload;
  const error =
    typeof payload === 'string'
      ? [saveProfileErrorMapping[payload!] || SaveProfileErrors.Unknown]
      : payload;
  switch (action.type) {
    case SAVE_PROFILE_START:
      return {
        ...state,
        saveMessage: 'saving',
      };
    case SAVE_PROFILE_COMPLETE:
      return {
        ...state,
        saveMessage: 'saved',
        ...('saveErrors' in state ? { saveErrors: undefined } : {}),
      };
    case SAVE_PROFILE_RESET:
      return { ...state, ...initialMemberHomeProfileState };
    case SAVE_PROFILE_ERROR:
      return {
        ...state,
        saveErrors: error,
      };
    default:
      return state;
  }
};
